import { useMemo } from 'react';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { getPaymentRecordTotal } from '../../hooks/useApplyPayments';
import { COMMERCE_PAYMENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { Small } from 'foundations-components/transitional/components/Small';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const alwaysUndefined = () => undefined;
const PaymentOption = ({
  option,
  currencyCode,
  balanceDue,
  onChange,
  selected
}) => {
  const disabled = getPaymentRecordTotal(option) > balanceDue;
  const emailProperty = useMemo(() => {
    return option.properties.find(property => property.name === 'hs_customer_email');
  }, [option]);
  const paymentId = useMemo(() => {
    return option.properties.find(property => property.name === 'hs_payment_id');
  }, [option]);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(Tooltip, {
      use: disabled ? 'default' : 'longform',
      title: getPaymentRecordTotal(option) > balanceDue ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.modals.applyExistingPayment.paymentExceedsBalance"
      }) : /*#__PURE__*/_jsxs(View, {
        marginBlockEnd: "200",
        as: "div",
        children: [/*#__PURE__*/_jsxs(TruncateString, {
          tooltip: false,
          children: [/*#__PURE__*/_jsx(View, {
            paddingInlineEnd: "200",
            as: "span",
            children: `${option.primaryDisplayProperty.definition.label}:`
          }), /*#__PURE__*/_jsx(FormattedPropertyV2, {
            objectTypeId: COMMERCE_PAYMENT_TYPE_ID,
            value: option.primaryDisplayProperty.value,
            property: option.primaryDisplayProperty.definition,
            getDraftValue: alwaysUndefined,
            getSavedValue: alwaysUndefined
          })]
        }, option.primaryDisplayProperty.name), option.secondaryDisplayProperties.map(property => {
          return /*#__PURE__*/_jsxs(TruncateString, {
            tooltip: false,
            children: [/*#__PURE__*/_jsx(View, {
              paddingInlineEnd: "200",
              as: "span",
              children: `${property.definition.label}:`
            }), /*#__PURE__*/_jsx(FormattedPropertyV2, {
              objectTypeId: COMMERCE_PAYMENT_TYPE_ID,
              value: property.value,
              property: property.definition,
              getDraftValue: alwaysUndefined,
              getSavedValue: alwaysUndefined
            })]
          }, property.name);
        })]
      }),
      children: /*#__PURE__*/_jsxs(Checkbox, {
        "data-test-id": "payment-option-checkbox",
        description: /*#__PURE__*/_jsxs(Small, {
          use: "help",
          children: [/*#__PURE__*/_jsx(View, {
            paddingInlineEnd: "200",
            as: "span",
            children: `${paymentId.definition.label}:`
          }), /*#__PURE__*/_jsx(FormattedPropertyV2, {
            objectTypeId: COMMERCE_PAYMENT_TYPE_ID,
            value: paymentId.value,
            property: paymentId.definition,
            getDraftValue: alwaysUndefined,
            getSavedValue: alwaysUndefined
          })]
        }),
        disabled: disabled,
        onChange: event => onChange(event.target.checked, option),
        checked: selected,
        inline: true,
        marginBlockEnd: "200",
        children: [/*#__PURE__*/_jsx(FormattedIntlCurrency, {
          currencyCode: currencyCode,
          value: getPaymentRecordTotal(option)
        }), ' (', /*#__PURE__*/_jsx(FormattedPropertyV2, {
          objectTypeId: COMMERCE_PAYMENT_TYPE_ID,
          value: emailProperty.value,
          property: emailProperty.definition,
          getDraftValue: alwaysUndefined,
          getSavedValue: alwaysUndefined
        }), ')']
      }, option.id)
    })
  });
};
export default PaymentOption;